import React, { FC } from 'react';

import iconOrange from 'utils/icons/my-team/icon-orange.svg';
// import iconpeople from 'utils/icons/my-team/people.svg';

const LeftCard: FC<{ registeredPeople?: number }> = ({ registeredPeople = 0 }) => {
  const hasPeople = registeredPeople > 0;
  // const isPlural = registeredPeople !== 1;

  // const registeredPeopleText = `${registeredPeople} pessoa${isPlural ? 's' : ''}`;
  const contentText = hasPeople
    ? 'Gerencie o cadastro da sua equipe e o programa de fidelidade VoeBiz.'
    : 'Você pode incluir uma pessoa por vez ou importar uma lista com várias pessoas. Vamos lá?';
  const buttonText = hasPeople ? 'Acessar' : 'Cadastrar equipe';

  return (
    <div className="my-team__container__card">
      <img className="my-team__container__card__icon" src={iconOrange} alt="" />

      <h3 className="my-team__container__card__title">Gerenciamento de equipe</h3>
      {!hasPeople && (
        <p className="my-team__container__card__text">
          <strong>Você ainda não cadastrou sua equipe</strong>
        </p>
      )}
      <p className="my-team__container__card__text">{contentText}</p>
      {/* <p className="my-team__container__card__text">
        <img src={iconpeople} alt="" /> <strong>Equipe cadastrada:</strong> <span>{registeredPeopleText}</span>
      </p> */}

      <div className="my-team__container__card__button">
        <a className="my-team__container__card__button-link" href="/beneficiarios" title="Minha equipe">
          {buttonText}
        </a>
      </div>
    </div>
  );
};

LeftCard.defaultProps = { registeredPeople: undefined };

export default LeftCard;
